// extracted by mini-css-extract-plugin
export default {"products":"Cz-z","card":"Dz-z","oosMessaging":"Ez-z"};